import { useGridPrivateApiContext as useCommunityGridPrivateApiContext } from '@mui/x-data-grid/internals';
export const useGridPrivateApiContext = useCommunityGridPrivateApiContext;